<template>
  <el-container class="page" :style="{ fontFamily: selectedFont }">
    <el-main class="no-padding">
      <div class="login"></div>
      <el-row justify="center" type="flex" align="middle">
        <el-col :xs="22" :sm="12" :md="8" :lg="6" :xl="6">
          <el-card class="login-card">
            <div slot="header" class="clearfix text-center">
              <img :src="logo" alt="logo" height="60px" />
            </div>
            <el-form label-position="top">
              <el-alert v-show="notauthorization" type="error" effect="dark"
                style="margin-top: 10px; margin-bottom: 10px">Usuário e senha são inválidos!</el-alert>
              <el-row :gutter="25" class="mb-20">
                <el-col :span="24">
                  <el-form-item>
                    <el-input maxlength="80" ref="username" v-model="username"
                      @keyup.enter.native="$refs.password.$el.children[1].focus()">
                      <template slot="prepend">
                        <i class="el-icon-user"></i>
                      </template>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="25" class="mb-20">
                <el-col :span="24">
                  <el-form-item>
                    <el-input maxlength="80" ref="password" type="password" @keyup.enter.native="submit"
                      v-model="password">
                      <template slot="prepend">
                        <i class="el-icon-lock"></i>
                      </template>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="25" class="mb-20">
                <el-col :span="12">
                  <el-checkbox>Lembrar</el-checkbox>
                </el-col>
                <el-col :span="12" style="text-align: right">
                  <el-link @click="forget()" type="info">Esqueceu a senha?</el-link>
                </el-col>
              </el-row>
              <el-row :gutter="25" style="padding-bottom: 15px;">
                <el-col :span="22" :offset="1">
                  <el-button class="w-100" @click="submit()" :disabled="loading" v-loading="loading"
                    type="primary">ACESSAR</el-button>
                </el-col>
              </el-row>
            </el-form>
          </el-card>
        </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import config from "@/sites/config.json"

export default {
  computed: {
    ...mapGetters("auth", [
      "authenticating",
      "authenticationError",
      "authenticationErrorCode",
    ]),
    logo() {
      return this.site.pages.login.logo
    }
  },
  methods: {
    ...mapActions("auth", ["login"]),
    setup() {
      console.log('favicon', document.querySelector('link[rel="icon"]'));
      const favicon = document.querySelector('link[rel="icon"]');
      console.log('favicon', favicon, this.site);
      if (favicon) {
        favicon.href = this.site.icon;
      }
      this.selectedFont = this.site["Font-family"];
      document.title = this.site.pages.login.title;
    },
    submit: function () {
      var vm = this;
      vm.notauthorization = false;
      vm.loading = true;
      this.login({
        email: this.username,
        password: this.password,
      })
        .then((response) => {
          vm.$bus.$emit("logged", "User logged");
          vm.$router.replace({
            name: "home",
          });
        })
        .catch((error) => {
          this.notauthorization = true;
        })
        .finally(() => {
          vm.loading = false;
        });
    },
    enter: function (ev) {
      if (ev.key == "Enter") {
        const vm = this;
        vm.$refs.password.$el.children[1].focus();
      }
    },
    forget() {
      var vm = this;
      vm.$router.replace({
        name: "forget",
      });
    },
  },
  mounted() {
    const vm = this;
    const hostname = window.location.hostname;
    const parts = hostname.split('.');
    const site = parts.length === 4 ? parts[0] : 'default';
    vm.site = config[site] || config['default'];
    this.setup();
    setTimeout(function () {
      vm.$refs.username.$el.children[1].focus();
    }, 300);
  },
  data() {
    return {
      username: "",
      password: "",
      notauthorization: 0,
      loading: false,
      site: config["default"],
      selectedFont: "Avenit",
    };
  },
};
</script>
<style>
.border-0 {
  margin-top: 50px;
  margin-left: 50px;
}

@media only screen and (min-width: 966px) {
  .border-0 {
    margin-top: 50px;
    margin-left: 10px;
    margin-right: 10px;
  }
}

@media only screen and (max-width: 600px) {
  .border-0 {
    margin-top: 50px;
    margin-left: 10px;
    margin-right: 10px;
  }
}

@media only screen and (min-width: 965px) {
  .page:before {
    flex: 0 1 474px;
  }
}

@media only screen and (min-width: 600px) and (max-width: 965px) {
  .page:before {
    flex: 0 1 274px;
  }
}

@media only screen and (max-width: 600px) {
  .page:before {
    display: none;
  }
}

.login {
  height: 100%;
  width: 100%;
  position: absolute;
  background: url('../../assets/login.jpg') no-repeat center center fixed !important;
  background-size: cover !important;
  background-blend-mode: overlay;
  opacity: 0.8;
}

.no-padding {
  padding: 0px !important;
}

.text-light {
  color: #000 !important;
}

.mb-20 {
  margin-bottom: 20px !important;
}

.w-100 {
  width: 100% !important;
}

.login-card {
  margin-top: 150px;
}

@media only screen and (max-width: 600px) {
  .login-card {
    margin-top: 50px;
  }
}
</style>
